import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetRemoteLockDisconnectedUsersRequest = {
  buildingId: number
}

export type RemoteLockDisconnectedUser = {
  id: string
  name: string
}

export const getRemoteLockDisconnectedUsersQueryKey = (
  data: GetRemoteLockDisconnectedUsersRequest,
) => ['useGetRemoteLockDisconnectedUsers', data]

const getRemoteLockDisconnectedUsers = async (data: GetRemoteLockDisconnectedUsersRequest) => {
  const response = await authAPI.get<RemoteLockDisconnectedUser[]>(
    `/remote-lock/disconnected/${data.buildingId}`,
  )
  return response.data
}

export const useGetRemoteLockDisconnectedUsers = (
  data: GetRemoteLockDisconnectedUsersRequest,
  enabled = false,
) =>
  useQuery({
    enabled: enabled && Boolean(data.buildingId),
    queryFn: () => getRemoteLockDisconnectedUsers(data),
    queryKey: getRemoteLockDisconnectedUsersQueryKey(data),
  })
